import React from 'react'
import Resize from 'lib/services/resize'
import { widerThan, narrowerThan } from '../config/breakpoints'

export default class Match extends React.PureComponent {
  constructor(props, context) {
    super(props, context)

    this.state = {
      width: Resize.get().width
    }
  }

  componentDidMount() {
    Resize.listen(this.setDimensions, this)
  }

  componentWillUnmount() {
    Resize.ignore(this.setDimensions, this)
  }

  setDimensions({ width }) {
    this.setState({ width })
  }

  renderNonMatch() {
    let { children } = this.props

    return typeof children === 'function' ? children(false) : null
  }

  renderMatch() {
    let { children } = this.props

    return typeof children === 'function'
      ? children(true) || null
      : children || null
  }

  render() {
    const { min, max } = this.props
    const { width } = this.state

    if (
      (min != null && narrowerThan(min, width)) ||
      (max != null && widerThan(max, width))
    ) {
      return this.renderNonMatch()
    }

    return this.renderMatch()
  }
}



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/match.js